import type { IUseTooltipDelayedState } from "app/pages/sales-intelligence/sub-modules/signals/hooks/signals-tooltip/useTooltipDelayedState";

interface IUseSignalTooltipDelayedContainerProps {
    onTooltipOpen: () => void;
    tooltipDelayedState: IUseTooltipDelayedState;
}

interface IUseSignalTooltipDelayedContainerResponse {
    onMouseEnter: VoidFunction;
    onMouseLeave: VoidFunction;
}

export const useSignalTooltipDelayed = ({
    onTooltipOpen,
    tooltipDelayedState,
}: IUseSignalTooltipDelayedContainerProps): IUseSignalTooltipDelayedContainerResponse => {
    const onMouseEnter = () => {
        tooltipDelayedState.onTooltipEnable(onTooltipOpen);
    };

    const onMouseLeave = () => {
        tooltipDelayedState.onTooltipDisable();
    };

    return {
        onMouseEnter,
        onMouseLeave,
    };
};
